// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d3409d7f","455":"b72dcd13","977":"b64a324c"}[chunkId] + ".chunk.js";
};